import { render, staticRenderFns } from "./biotrackDetails.template.vue?vue&type=template&id=69927dde&scoped=true&"
var script = {}
import style0 from "./biotrackDetails.template.vue?vue&type=style&index=0&id=69927dde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69927dde",
  null
  
)

export default component.exports